import { Theme } from '@mui/material'

const useStyles = {
  chipSelected: (theme: Theme) => ({
    color: theme.palette.primary.dark,
    backgroundColor: theme.palette.primary.shades['12p'],
    '&:hover': {
      backgroundColor: theme.palette.primary.shades['12p'],
    },
    '& > svg': {
      fill: theme.palette.primary.dark,
    },
  }),
  returnItemsList: {
    overflowY: 'auto',
    maxHeight: '165px',
  },
}
export default useStyles
